import { MdOutlineContentCopy, MdShare } from "react-icons/md";
import React from "react";
import { useGlobalContext } from "../context";
import Colorcode from "./Colorcode";
import Inputs from "./Inputs";
import { setMessage } from "../utils";
const PickerBody = () => {
  const {
    color4copy,
    isRGB,
    setisRGB,
    colors,
    randomColor,
    showRecentBtn,
    addColorToRecent,
    rgbCode,
    hexCode,
  } = useGlobalContext();
  return (
    <>
      <div className="picker-body text-center">
        <div className="flex items-center mb-3 justify-center gap-2">
          <MdOutlineContentCopy
            onClick={() => {
              navigator.clipboard.writeText(color4copy);
              setMessage(`color ${color4copy} copied`);
            }}
            className="relative w-[30px]  cursor-pointer"
          />

          {/* Share Color Button */}
          <h4 className="text-2xl lowercase py-2  m-0 select-none">
            <Colorcode />
          </h4>
          <MdShare
            className="relative w-[30px] cursor-pointer"
            onClick={() => {
              // Generate shareable link for current color
              const colorParam = isRGB
                ? rgbCode
                    .replace(/[^0-9,]/g, "")
                    .split(",")
                    .map((num) => num.padStart(3, "0"))
                    .join("")
                : hexCode.replace("#", "");
              const url = `${window.location.origin}?color=${colorParam}`;
              navigator.clipboard.writeText(url);
              if (navigator.share) {
                navigator
                  .share({
                    title: "Share Color",
                    text: `Check out this color: ${isRGB ? rgbCode : hexCode}`,
                    url,
                  })
                  .catch(() => {});
              }
              setMessage("Shareable color link copied!");
            }}
          />
        </div>
        <div className="flex items-center flex-wrap justify-center gap-2">
          <button
            className="convertColorcodeBtn customBtn"
            onClick={() => {
              setisRGB(!isRGB);
              setMessage(`color type changed to ` + (!isRGB ? `rgb` : `hex`));
            }}
          >
            convert to {isRGB ? "hex" : "rgb"}
          </button>
          <button
            className="randomBtn customBtn"
            onClick={() => {
              randomColor();
            }}
          >
            generate random
          </button>
          {showRecentBtn && (
            <button
              className="add2recentBtn customBtn"
              onClick={() => {
                addColorToRecent();
              }}
            >
              add to recent
            </button>
          )}
        </div>
        {colors.map((clr, index) => {
          return <Inputs key={index} color={clr} />;
        })}
      </div>
    </>
  );
};

export default PickerBody;
